import React from "react";

interface SvgProps extends React.SVGProps<SVGSVGElement> {
  size?: "small" | "middle" | "large";
}

const FieldErrorIcon: React.FC<SvgProps> = ({ size = "small", ...props }) => (
  <>
    {size === "small" && (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_11646_4031)">
          <path
            d="M7.99967 5.3335V8.00016M7.99967 10.6668H8.00634M14.6663 8.00016C14.6663 11.6821 11.6816 14.6668 7.99967 14.6668C4.31778 14.6668 1.33301 11.6821 1.33301 8.00016C1.33301 4.31826 4.31778 1.3335 7.99967 1.3335C11.6816 1.3335 14.6663 4.31826 14.6663 8.00016Z"
            stroke="#F04438"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_11646_4031">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )}

    {size === "middle" && (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.5001 13.3332V9.99984M10.5001 6.6665H10.5084M18.8334 9.99984C18.8334 14.6022 15.1025 18.3332 10.5001 18.3332C5.89771 18.3332 2.16675 14.6022 2.16675 9.99984C2.16675 5.39746 5.89771 1.6665 10.5001 1.6665C15.1025 1.6665 18.8334 5.39746 18.8334 9.99984Z"
          strokeWidth="1.67"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )}

    {size === "large" && (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 16V12M12.5 8H12.51M22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12Z"
          strokeWidth="1.67"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )}
  </>
);

export default FieldErrorIcon;
